"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compIdToCssSelector = exports.isDefaultCompId = exports.getDefaultCompId = exports.getHoverCompId = exports.HOVER_DATA_MODE = exports.DEFAULT_DATA_MODE = exports.HOVER_SUFFIX = exports.MODES_TYPE = void 0;
exports.MODES_TYPE = {
    hover: 'HOVER',
    default: 'DEFAULT',
};
exports.HOVER_SUFFIX = ':hover';
exports.DEFAULT_DATA_MODE = '[data-mode=default]';
exports.HOVER_DATA_MODE = '[data-mode=hover]';
const getHoverCompId = (compId) => `${compId}${exports.HOVER_SUFFIX}`;
exports.getHoverCompId = getHoverCompId;
const getDefaultCompId = (compId) => (compId ? compId.replace(exports.HOVER_SUFFIX, '') : compId);
exports.getDefaultCompId = getDefaultCompId;
const isDefaultCompId = (compId) => !compId.endsWith(exports.HOVER_SUFFIX);
exports.isDefaultCompId = isDefaultCompId;
const COMP_SELECTOR_PLACEHOLDER = '#<%= compId %>';
const compIdToCssSelector = (compId, shouldReturnPlaceholderSelector) => {
    const defaultCompId = (0, exports.getDefaultCompId)(compId);
    const fallbackSelector = shouldReturnPlaceholderSelector ? `${COMP_SELECTOR_PLACEHOLDER}` : `#${compId}`;
    return compId.endsWith(exports.HOVER_SUFFIX) ? `${exports.HOVER_DATA_MODE} #${defaultCompId}` : fallbackSelector;
};
exports.compIdToCssSelector = compIdToCssSelector;
//# sourceMappingURL=hoverBoxUtils.js.map